// ============================================
// NAVIGATION UTILITIES
// Utiliser useNavigate() au lieu de window.location.href
// pour une vraie navigation SPA sans reload
// ============================================

/**
 * Routes canoniques de l'application
 * /biens-v2 redirige vers /properties
 */
export const ROUTES = {
  // Pages principales
  HOME: '/',
  DASHBOARD: '/',
  PROPERTIES: '/properties',
  CONTACTS: '/contacts',
  DEMANDES_CONTACT: '/demandes-contact',
  FAVORIS: '/favoris',
  MARKETING: '/marketing',
  OUTILS: '/outils',
  DOCUMENTS: '/documents',
  
  // Sous-routes
  PROPERTY_VIEW: (id) => `/properties/${id}/view`,
  PROPERTY_EDIT: (id) => `/properties/${id}/edit`,
  CONTACT_NEW: '/contacts/nouveau',
  
  // Filtres
  PROPERTIES_FILTERED: (filter) => `/properties?filter=${filter}`,
  
  // Legacy (pour compatibilité temporaire)
  BIENS_V2: '/biens-v2',
};

/**
 * Helper pour naviguer avec des paramètres de query
 * @param {Function} navigate - useNavigate() hook
 * @param {string} path - chemin de base
 * @param {Object} params - paramètres de query (optionnel)
 */
export const navigateTo = (navigate, path, params = {}) => {
  const queryString = Object.keys(params).length > 0 
    ? '?' + new URLSearchParams(params).toString()
    : '';
  navigate(path + queryString);
};

/**
 * Navigation vers la liste des biens
 */

// lot CE — retour à la liste des biens EN CONSERVANT ses filtres.
// Adresse mémorisée par PropertiesListPage (sessionStorage : propre à l'onglet, donc deux
// listes ouvertes en parallèle ne se mélangent pas). Repli : la liste complète.
export const adresseRetourListe = () => {
  try {
    const memo = sessionStorage.getItem('komerces:retourListe');
    if (memo && memo.startsWith('/properties')) return memo;
  } catch { /* stockage indisponible : on revient à la liste complète */ }
  return '/properties';
};

export const goToProperties = (navigate, filter = null) => {
  if (filter) {
    navigate(`${ROUTES.PROPERTIES}?filter=${filter}`);
  } else {
    navigate(ROUTES.PROPERTIES);
  }
};

/**
 * Navigation vers un bien spécifique (consultation)
 */
export const goToPropertyView = (navigate, propertyId) => {
  navigate(ROUTES.PROPERTY_VIEW(propertyId));
};

/**
 * Navigation vers l'édition d'un bien
 */
export const goToPropertyEdit = (navigate, propertyId) => {
  navigate(ROUTES.PROPERTY_EDIT(propertyId));
};

/**
 * Navigation vers les contacts
 */
export const goToContacts = (navigate, action = null) => {
  if (action) {
    navigate(`${ROUTES.CONTACTS}?action=${action}`);
  } else {
    navigate(ROUTES.CONTACTS);
  }
};

/**
 * Navigation vers le dashboard
 */
export const goToDashboard = (navigate) => {
  navigate(ROUTES.DASHBOARD);
};

export default {
  ROUTES,
  navigateTo,
  goToProperties,
  goToPropertyView,
  goToPropertyEdit,
  goToContacts,
  goToDashboard,
};
